function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5163 28.6184C19.5163 29.5175 18.4223 29.9599 17.7974 29.3136L10.9333 22.2151C10.5494 21.8181 9.91647 21.8075 9.51942 22.1913L2.00763 29.4526C1.37294 30.0662 0.312607 29.6164 0.312607 28.7336L0.312609 1.95722C0.312609 1.40493 0.760325 0.957216 1.31261 0.957216L18.5163 0.957217C19.0686 0.957217 19.5163 1.40493 19.5163 1.95722L19.5163 28.6184Z",
  fill: "#E4C72D"
});
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    viewBox: "0 0 20 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.26017284.svg";
export { ForwardRef as ReactComponent };